import { DOCUMENT, Injectable, effect, inject } from '@angular/core';
import { KsgThemeService } from '@ksg/ui';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly doc = inject(DOCUMENT);
  private readonly ksg = inject(KsgThemeService);
  private hydrated = false;

  constructor() {

    effect(() => {
      const isDark = this.ksg.isDark();
      const isHighContrast = this.ksg.isHighContrast();
      if (!this.hydrated) return;
      this.write(environment.themeCookie, String(!isDark));
      this.write(environment.contrastCookie, String(isHighContrast));
    });
  }

  init(): void {
    const light = this.read(environment.themeCookie);
    const contrast = this.read(environment.contrastCookie);
    const size = this.read(environment.sizeCookieName);

    if (light === 'true') this.ksg.setTheme('light');
    else if (light === 'false') this.ksg.setTheme('dark');
    else this.ksg.setTheme(this.prefersDark() ? 'dark' : 'light');

    this.ksg.setContrast(contrast === 'true' ? 'high' : 'none');

    const html = this.doc.documentElement;
    if (html) html.style.fontSize = size || environment.defaultSize;

    this.hydrated = true;
  }

  private prefersDark(): boolean {
    try {
      return !!this.doc.defaultView?.matchMedia?.('(prefers-color-scheme: dark)').matches;
    } catch {
      return false;
    }
  }

  private read(key: string): string | null {
    try {
      return this.doc.defaultView?.localStorage.getItem(key) ?? null;
    } catch {
      return null;
    }
  }

  private write(key: string, value: string): void {
    try {
      this.doc.defaultView?.localStorage.setItem(key, value);
    } catch {

    }
  }
}
